// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calculator-container {
  width: 90%;
  margin: 1.5em auto;
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}

.calculator-container h1 {
  text-align: center;
  margin-bottom: 20px;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1.5em;
  color: #d23038;
}

.calculator-wrapper {
  display: flex; /* Use flexbox to align divs next to each other */
  flex-wrap: wrap; /* Allow wrapping if necessary */
  gap: 15px; /* Gap between the divs */
}

.calculator {
  flex: 1 1; /* Allow the calculator divs to take equal space */
  min-width: 300px; /* Minimum width to ensure responsiveness */
  overflow-x: auto;
}
.remove-calculator-button {
  display: flex;
  margin-bottom: 10px;
  border-radius: 2em;
  margin-left: -2em;
  font-size: 1.25em;
  padding: 0em;
  background: none;
  color: #b51f25;
}
.remove-calculator-button:hover {
  background-color: #f3f3f3;
  color: #d23038;
}
.calculator table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Fivo Sans Regular", sans-serif;
  background-color: #fff;
  border-radius: 1.5em;
}

.calculator table thead {
  text-align: center;
  background-color: #f8f8f8;
  padding: 8px;
  font-size: 1em;
  font-family: "Fivo Sans Medium", sans-serif;
  color: #333;
}

.calculator th,
.calculator td {
  padding: 10px 8px;
  font-size: 0.75em;
  color: #333;
  text-align: left;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #ddd;
}

.calculator tr:last-child td {
  border-bottom: none;
}

.calculator select,
.calculator input {
  width: 100%;
  padding: 0.5em;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 12px;
  font-family: "Fivo Sans Regular", sans-serif;
  background: #f3f3f3;
}

.calculator input[type="number"] {
  appearance: textfield;
  width: auto;
}

.current-range {
  font-size: 0.8em;
  color: #d23038;
  white-space: nowrap;
  text-align: right;
}

.calculator input[type="number"]::-webkit-outer-spin-button,
.calculator input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ModuleCalculator/ModuleCalculator.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,iDAAiD;EAChE,eAAe,EAAE,gCAAgC;EACjD,SAAS,EAAE,yBAAyB;AACtC;;AAEA;EACE,SAAO,EAAE,kDAAkD;EAC3D,gBAAgB,EAAE,2CAA2C;EAC7D,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EAGE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX","sourcesContent":[".calculator-container {\n  width: 90%;\n  margin: 1.5em auto;\n  background-color: #f9f9f9;\n  padding: 15px;\n  border-radius: 10px;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\n}\n\n.calculator-container h1 {\n  text-align: center;\n  margin-bottom: 20px;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1.5em;\n  color: #d23038;\n}\n\n.calculator-wrapper {\n  display: flex; /* Use flexbox to align divs next to each other */\n  flex-wrap: wrap; /* Allow wrapping if necessary */\n  gap: 15px; /* Gap between the divs */\n}\n\n.calculator {\n  flex: 1; /* Allow the calculator divs to take equal space */\n  min-width: 300px; /* Minimum width to ensure responsiveness */\n  overflow-x: auto;\n}\n.remove-calculator-button {\n  display: flex;\n  margin-bottom: 10px;\n  border-radius: 2em;\n  margin-left: -2em;\n  font-size: 1.25em;\n  padding: 0em;\n  background: none;\n  color: #b51f25;\n}\n.remove-calculator-button:hover {\n  background-color: #f3f3f3;\n  color: #d23038;\n}\n.calculator table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  background-color: #fff;\n  border-radius: 1.5em;\n}\n\n.calculator table thead {\n  text-align: center;\n  background-color: #f8f8f8;\n  padding: 8px;\n  font-size: 1em;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  color: #333;\n}\n\n.calculator th,\n.calculator td {\n  padding: 10px 8px;\n  font-size: 0.75em;\n  color: #333;\n  text-align: left;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid #ddd;\n}\n\n.calculator tr:last-child td {\n  border-bottom: none;\n}\n\n.calculator select,\n.calculator input {\n  width: 100%;\n  padding: 0.5em;\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  font-size: 12px;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  background: #f3f3f3;\n}\n\n.calculator input[type=\"number\"] {\n  -webkit-appearance: none;\n  -moz-appearance: textfield;\n  appearance: textfield;\n  width: auto;\n}\n\n.current-range {\n  font-size: 0.8em;\n  color: #d23038;\n  white-space: nowrap;\n  text-align: right;\n}\n\n.calculator input[type=\"number\"]::-webkit-outer-spin-button,\n.calculator input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
